'use client'

// The doorbell for the auth island. Privy stays entirely off the boot
// path; this tiny component decides when it's time: a couple of seconds
// after mount (so a returning visitor gets recognised while the world is
// still streaming in), or immediately when someone opens a door that
// needs an account. Mounting the island never re-parents the app, so the
// canvas and the sockets don't blink.

import { useEffect } from 'react'
import dynamic from 'next/dynamic'
import useGameStore from '../../stores/gameStore'
import { HAS_AUTH } from './useUser'

const PrivyIsland = dynamic(() => import('./PrivyIsland'), { ssr: false })

export default function AuthIsland() {
  const wanted = useGameStore((s) => s.authWanted || s.profileOpen || s.shrineOpen)
  const setAuthWanted = useGameStore((s) => s.setAuthWanted)

  useEffect(() => {
    const t = setTimeout(() => setAuthWanted(true), 2000)
    return () => clearTimeout(t)
  }, [setAuthWanted])

  // The page used to guard this. Now that it is mounted for every route,
  // the guard travels with it: an auth-dark deploy must stay dark.
  if (!HAS_AUTH || !wanted) return null
  return <PrivyIsland />
}
